// extracted by mini-css-extract-plugin
export default {"schoolSelectorWrapper":"Nav_schoolSelectorWrapper__se3Tt","schoolName":"Nav_schoolName__HjWt7"};